import {FieldConfig} from '../../dynamic-field/field.config';

export interface DatetimeFieldConfig extends FieldConfig<Date> {
    minDate?: Date | null;
    maxDate?: Date | null;
    showSpinners?: boolean;
    showSeconds?: boolean;
}
